<template>
  <click-to-edit
    v-model="scope.row.scale.weight_plan"
    :number-format="{decimals: 2, space:true}"
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.weight_plan')"
    placeholder=""
    @input="saveElementPropChange(scope.row, 'scale', {weight_plan:$event})"
  >
  </click-to-edit>
</template>

<script>


import ClickToEdit from "@/components/ClickToEdit.vue";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";

export default {
  name: 'element-weight-plan-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {

    }
  },

  methods: {

  }
}

</script>

<style>

</style>
